import $ = require("jquery");
import ko = require("knockout");
import komap = require("knockout.mapping");
import _ = require("underscore");
import Service = require("../Atlas/Service");

export = EmailComposer;


module EmailComposer {

    export interface IEmailPdfAttachment {
        FileNameWithoutExtension: KnockoutObservable<string>;
        PdfReportId?: KnockoutObservable<string>;
    }

    export interface IEmailStaticFileAttachment {
        Id: string;
        RoutingActionId: string;
        FileName: string;
        MimeType: string;
    }

    export interface IEmailStaticFileAttachmentsViewModel {
        existingFiles: KnockoutObservableArray<IEmailStaticFileAttachment>;
        newFiles: KnockoutObservableArray<File>;
    }

    export interface IEmail {
        EmailTo: KnockoutObservable<string>;
        EmailFrom: KnockoutObservable<string>;
        EmailCc: KnockoutObservable<string>;
        EmailBcc: KnockoutObservable<string>;
        EmailSubject: KnockoutObservable<string>;
        EmailBody: KnockoutObservable<string>;

        EmailPdfAttachments?: KnockoutObservableArray<any>;
        emailStaticFileAttachmentsViewModel?: IEmailStaticFileAttachmentsViewModel;

        CreateEmailPdfAttachment() : IEmailPdfAttachment;
    }

    export interface IEmailComposerParams {
        emailViewModel: IEmail | KnockoutObservable<IEmail>;
        defaultEmail?: IEmail;
        prefix?: string;
        sampleMergeUrl?: string;
        availablePdfReports?: ITextValue[];
        allowStaticFileAttachments?: boolean;
        staticFileAttachmentPreviewUrl?: string;
        maximumStaticFileSizeMb?: number;
    }

    export class EmailComposerViewModel {
        private emailVm: IEmail;
        private namePrefix: string;
        private idPrefix: string;
        private sampleMergeUrl: string;
        private isPreviewing: KnockoutObservable<boolean>;
        private isLoading: KnockoutObservable<boolean>;
        private previewEmailVm: IEmail;
        private pendingXhr: JQueryXHR;
        private allowPdfAttachments: KnockoutObservable<boolean>;
        private allowStaticFileAttachments: boolean;
        private availablePdfReports: KnockoutObservable<ITextValue[]>;
        private lastActionText: KnockoutObservable<string>;
        private staticFileLastActionText: KnockoutObservable<string>;
        private fileUploadError: KnockoutObservable<string>;
        private staticFileAttachmentPreviewUrl: string;
        private maximumStaticFileSizeMb: number;
        private emailFromCampusWarning: KnockoutComputed<boolean>;
        private emailFromTextMergeWarning: KnockoutComputed<boolean>;

        public constructor(params: IEmailComposerParams, componentInfo) {
            this.allowPdfAttachments = ko.observable(false);
            this.availablePdfReports = ko.observable([]);
            this.lastActionText = ko.observable("");
            this.staticFileLastActionText = ko.observable("");
            this.fileUploadError = ko.observable(null);

            if (params) {
                if (params.emailViewModel) {
                    this.emailVm = ko.unwrap(params.emailViewModel);
                    if (!this.emailVm.EmailPdfAttachments) {
                        this.emailVm.EmailPdfAttachments = ko.observableArray([]);
                    }
                    if (!this.emailVm.emailStaticFileAttachmentsViewModel) {
                        this.emailVm.emailStaticFileAttachmentsViewModel = {
                            existingFiles: ko.observableArray([]),
                            newFiles: ko.observableArray([]),
                        }
                    }
                } else
                    throw "emailViewModel cannot be null";

                if (params.prefix && params.prefix.length) {
                    this.namePrefix = params.prefix + ".";
                    this.idPrefix = params.prefix.replace(".", "_") + "_";
                } else {
                    this.namePrefix = "";
                    this.idPrefix = "";
                }

                if (params.sampleMergeUrl) {
                    this.sampleMergeUrl = params.sampleMergeUrl;
                }

                if (params.availablePdfReports && params.availablePdfReports.length) {
                    this.allowPdfAttachments(true);
                    this.availablePdfReports(params.availablePdfReports);
                }

                this.allowStaticFileAttachments = params.allowStaticFileAttachments === true;
                this.staticFileAttachmentPreviewUrl = params.staticFileAttachmentPreviewUrl || "";
                this.maximumStaticFileSizeMb = params.maximumStaticFileSizeMb;

            } else
                throw "params cannot be null";

            this.isPreviewing = ko.observable(false);
            this.isLoading = ko.observable(false);

            let pevm: IEmail = {
                EmailTo: ko.observable(this.emailVm.EmailTo()),
                EmailFrom: ko.observable(this.emailVm.EmailFrom()),
                EmailCc: ko.observable(this.emailVm.EmailCc()),
                EmailBcc: ko.observable(this.emailVm.EmailBcc()),
                EmailSubject: ko.observable(this.emailVm.EmailSubject()),
                EmailBody: ko.observable(this.emailVm.EmailBody()),
                EmailPdfAttachments: ko.observableArray(this.emailVm.EmailPdfAttachments()),
                CreateEmailPdfAttachment: () => null
            };
            this.previewEmailVm = pevm;

            

            this.pendingXhr = null;

            $(componentInfo.element).on("clear-error", () => this.resetEditor());

            ko.utils.domNodeDisposal.addDisposeCallback(componentInfo.element, function () {
                $(componentInfo.element).off("clear-error");
            });

            const netIdRegex = new RegExp("^[a-zA-Z0-9-_]{1,50}$", "i");
            const supportedRealm = new RegExp("^(illinois|uis|uic|uillinois).edu$", "i");
            this.emailFromCampusWarning = ko.pureComputed(() => {
                const val = this.emailVm.EmailFrom()?.toLocaleLowerCase().trim();

                if (!val)
                    return false;

                let nrp = Service.parseFqdnToNetIdRealmPair(val);
                return !netIdRegex.test(nrp.CN) || !supportedRealm.test(nrp.Realm);
            });

            const mergeTokenRegex = /\[\[[^(\]\])\[]+\]\]/;
            this.emailFromTextMergeWarning = ko.pureComputed(() => {
                const val = this.emailVm.EmailFrom()?.toLocaleLowerCase().trim();

                if (!val)
                    return false;

                return mergeTokenRegex.test(val);
            });
        }

        private actuallyGetMergeValues() {
            if (this.pendingXhr)
                this.pendingXhr.abort();

            var data = komap.toJS(this.emailVm);
            this.pendingXhr = $.post(this.sampleMergeUrl, { email: data });

            this.isLoading(true);

            this.pendingXhr.done(result => {
                if (result && result.Successful) {
                    this.previewEmailVm.EmailTo(result.Data.EmailTo);
                    this.previewEmailVm.EmailFrom(result.Data.EmailFrom);
                    this.previewEmailVm.EmailCc(result.Data.EmailCc);
                    this.previewEmailVm.EmailBcc(result.Data.EmailBcc);
                    this.previewEmailVm.EmailSubject(result.Data.EmailSubject);
                    this.previewEmailVm.EmailBody(result.Data.EmailBody);
                    this.previewEmailVm.EmailPdfAttachments(result.Data.EmailPdfAttachments || []);
                } else {
                    Service.reportMessageResultError(result);
                }
            }).fail((errorDetails, statusText) => {
                if (statusText !== "abort")
                    Service.reportMessageResultError(errorDetails);
            }).always(() => {
                this.isLoading(false);
            });
        }

        clickPreview() {
            if (this.isPreviewing()) {
                this.isPreviewing(false);
                return;
            }

            this.previewEmailVm.EmailTo(this.emailVm.EmailTo());
            this.previewEmailVm.EmailFrom(this.emailVm.EmailFrom());
            this.previewEmailVm.EmailCc(this.emailVm.EmailCc());
            this.previewEmailVm.EmailBcc(this.emailVm.EmailBcc());
            this.previewEmailVm.EmailSubject(this.emailVm.EmailSubject());
            this.previewEmailVm.EmailBody(this.emailVm.EmailBody());

            var atts = _.map(this.emailVm.EmailPdfAttachments(), (x: IEmailPdfAttachment) => { return { FileNameWithoutExtension: x.FileNameWithoutExtension() } });
            this.previewEmailVm.EmailPdfAttachments(atts);

            this.actuallyGetMergeValues();
            this.isPreviewing(true);
        }

        getPreviewNameForIndex(index: number) {
            if (this.previewEmailVm.EmailPdfAttachments && this.previewEmailVm.EmailPdfAttachments() && this.previewEmailVm.EmailPdfAttachments()[index]) {
                return this.previewEmailVm.EmailPdfAttachments()[index].FileNameWithoutExtension;
            }
            return "";
        }

        updateFocusAfterAdd(element) {
            var wrapper = $(element).closest("tbody");
            wrapper.children().last().find("select").focus();
        }

        updateFocusBeforeRemove(element) {
            let el = $(element);
            if (el.is("tr")) {
                let nextRow = el.next("tr");
                if (!nextRow.length) {
                    let prevRow = el.prev("tr");
                    if (!prevRow.length) {
                        $(`#${this.idPrefix}add_pdf_attach_btn`).focus();
                    } else {
                        prevRow.find("button.data-delete-btn").focus();
                    }
                } else {
                    nextRow.find("button.data-delete-btn").focus();
                }
            }
            el.remove();
        }

        addPdfAttachment() {
            var pdfReport = this.availablePdfReports()[0];
            var newAttachment = this.emailVm.CreateEmailPdfAttachment();
            newAttachment.PdfReportId(pdfReport.Value);
            this.emailVm.EmailPdfAttachments.push(newAttachment);
            this.lastActionText(`PDF report added. ${this.emailVm.EmailPdfAttachments().length} attachments total.`);
        }
        removeAttachment(attachment: IEmailPdfAttachment) {
            this.emailVm.EmailPdfAttachments.remove(attachment);
            let pdfReport: ITextValue;
            if (this.availablePdfReports)
                pdfReport = _.find(this.availablePdfReports(), x => x.Value === attachment.PdfReportId());
            this.lastActionText(`${pdfReport ? pdfReport.Text : ""} PDF report ${attachment.FileNameWithoutExtension()} deleted. ${this.emailVm.EmailPdfAttachments().length} attachments total.`);
        }

        filePicked(element: HTMLInputElement) {
            this.fileUploadError(null);
            if (element) {
                if (element.files && element.files.length && this.validateUpload(element.files[0])) {
                    let esfa = this.emailVm.emailStaticFileAttachmentsViewModel as IEmailStaticFileAttachmentsViewModel;
                    esfa.newFiles.push(element.files[0]);
                    this.staticFileLastActionText(`Static file picked. ${this.emailVm.emailStaticFileAttachmentsViewModel.existingFiles().length + this.emailVm.emailStaticFileAttachmentsViewModel.newFiles().length} attachments total.`);
                }
                element.value = null;
                return;
            }
            this.fileUploadError("Unable to upload file. Please try again.");
        }

        validateUpload(file: File): boolean {
            if (!file.name || file.name.length > 200) {
                this.fileUploadError("File name must be between 1 and 200 characters.");
                return false;
            }

            if (this.maximumStaticFileSizeMb && file.size > this.maximumStaticFileSizeMb*1024*1024) {
                this.fileUploadError(`File '${file.name}' is too large. Maximum file size is ${this.maximumStaticFileSizeMb} MB.`);
                return false;
            }

            return true;
        }

        removePickedFile(data: File) {
            this.emailVm.emailStaticFileAttachmentsViewModel.newFiles.remove(data);
            this.staticFileLastActionText(`File ${data.name} deleted. ${this.emailVm.emailStaticFileAttachmentsViewModel.existingFiles().length + this.emailVm.emailStaticFileAttachmentsViewModel.newFiles().length} attachments total.`);
        }

        removeExistingFile(file: IEmailStaticFileAttachment) {
            var confirmDelete = confirm(`Really remove ${file.FileName}?`);
            if (confirmDelete) {
                this.emailVm.emailStaticFileAttachmentsViewModel.existingFiles.remove(file);
                this.staticFileLastActionText(`File ${file.FileName} deleted. ${this.emailVm.emailStaticFileAttachmentsViewModel.existingFiles().length + this.emailVm.emailStaticFileAttachmentsViewModel.newFiles().length} attachments total.`);
            }
        }

        resetEditor() {
            this.fileUploadError(null);
        }
    }
}